import { render, staticRenderFns } from "./Replace.vue?vue&type=template&id=9d6dd524&scoped=true"
import script from "./Replace.vue?vue&type=script&lang=js"
export * from "./Replace.vue?vue&type=script&lang=js"
import style0 from "./Replace.vue?vue&type=style&index=0&id=9d6dd524&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6dd524",
  null
  
)

export default component.exports